import { TbReceiptTax } from 'react-icons/tb'

import { TopMenu } from '../Components/TopMenu'
import { DICTIONARY_SEARCH_FIELDS } from '../Contracts/DictionaryFields'
import { CRM_LIST_COLUMNS, crmListFields } from '../Contracts/CrmListFields'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Довідник «Форми оподаткування» (сім'я `CrmList`, `SPEC-007` §4).
 *
 * Оподаткування в реквізитах клієнта, перевізника, юрособи; опис потрапляє в друк (`SPEC-012`).
 *
 * Сторінку бачить лише той, кому бек дає створення довідників, тобто
 * адміністратор (`pageConfig.accessFn`, `SPEC-007` §7.1); читати довідник для
 * селектів може кожен.
 */
export const ListFormTaxationResource: IResourceConfig = {
    title: 'Форми оподаткування',
    fields: crmListFields({
        // Підставляється в друк як `<prefix>.descriptionDocuments` (`SPEC-012`)
        descriptionDocuments: {
            label: 'Опис для документів',
            type: 'string',
        },
    }),
    table: {
        showColumns: [...CRM_LIST_COLUMNS, 'descriptionDocuments'],
    },
    filter: {
        includeFields: ['id'],
    },
    places: {
        top: <TopMenu current="forms-taxation" />,
    },
    restUrl: '/services/forms_taxation',
    pageUrl: '/settings/forms-taxation',
    pageConfig: {
        title: 'Форми оподаткування',
        icon: <TbReceiptTax />,
        accessFn: CheckDictionaryPageAccessTask,
    },
    settings: {
        searchFields: DICTIONARY_SEARCH_FIELDS,
    },
}
